const orderDepositApi = {
  queryList: "/manage/order/order/depositOrderList", // 定金单列表
  getTotalNum: "/manage/order/order/depositOrderCount", // 定金单各状态数量汇总
  exportDepositData: "/manage/order/order/downloadDepositOrder" // 导出定金单
};
export default orderDepositApi;



// WEBPACK FOOTER //
// ./src/service/basic/orderDepositApi.js